<template>
  <div id="devices">
    <div class="main">
      <div class="search_expand_area">
        <el-button type="text" @click="toggleSearchForm">
          {{$t('cmsg.search')}}
          <i class="el-icon-arrow-right el-icon--right"></i>
        </el-button>
      </div>
      <el-form
        :inline="true"
        :model="searchForm"
        size="mini"
        class="search_form"
        status-icon
        :validate-on-rule-change="false"
        :show-message="false"
      >
        <el-form-item :label="$t('cmsg.model')">
          <el-select v-model="searchForm.modelID" filterable>
            <el-option :label="$t('cmsg.all')" value></el-option>
            <el-option :label="$t('cmsg.hospital')" value="hospital"></el-option>
            <el-option :label="$t('cmsg.lab')" value="lab"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('cmsg.sn')">
          <el-input v-model="searchForm.serialNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('cmsg.belongType')">
          <el-select v-model="searchForm.ownerFactoryType" filterable>
            <el-option :label="$t('cmsg.all')" value></el-option>
            <el-option :label="$t('cmsg.hospital')" value="hospital"></el-option>
            <el-option :label="$t('cmsg.lab')" value="lab"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('cmsg.belongs')">
          <el-input v-model="searchForm.ownerFactoryName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('cmsg.owner')">
          <el-input v-model="searchForm.ownerUserName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('cmsg.usageType')">
          <el-select v-model="searchForm.userFactoryType" filterable>
            <el-option :label="$t('cmsg.all')" value></el-option>
            <el-option :label="$t('cmsg.hospital')" value="hospital"></el-option>
            <el-option :label="$t('cmsg.lab')" value="lab"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('cmsg.usageName')">
          <el-input v-model="searchForm.userFactoryName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('cmsg.user')">
          <el-input v-model="searchForm.userUserName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="default"
            @click="searchSubmit"
            :disabled="tableLoading"
            :loading="tableLoading"
            icon="el-icon-3d-search"
          >{{$t('cmsg.search')}}</el-button>
          <el-button
            type="default"
            @click="onSearchReset"
            icon="el-icon-3d-reset"
          >{{$t('cmsg.reset')}}</el-button>
          <el-button
            type="default"
            @click="dentalDeviceForm.visible=true"
            v-if="perms.indexOf('dental.change_dental_list')>-1"
            icon="el-icon-3d-new"
          >{{$t('cmsg.new')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="items" stripe style="width: 100%">
        <el-table-column :label="$t('cmsg.device')">
          <template slot-scope="scope">
            <span v-if="scope.row.DeviceModel !== {}">{{scope.row.DeviceModel.CnName}}</span>
            {{scope.row.SN}}
            <el-popover
              placement="bottom"
              width="200"
              trigger="click"
              v-if="scope.row.Notes !== ''"
              :content="scope.row.Notes"
            >
              <el-button slot="reference" size="mini" type="text">{{$t('cmsg.other')}}</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column :label="$t('cmsg.belongs')">
          <template slot-scope="scope">
            <span
              v-if="scope.row.OwnerFactory !== {}"
            >{{scope.row.OwnerFactory.Name}}[{{$t(switchType(scope.row.OwnerFactory.Type))}}]</span>
            <span
              v-if="scope.row.Owner !== {}"
            >{{scope.row.Owner.NickName}} {{scope.row.Owner.Email}} {{scope.row.Owner.Phone}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('cmsg.usageSpec')">
          <template slot-scope="scope">
            <span
              v-if="scope.row.UserFactory !== {}"
            >{{scope.row.UserFactory.Name}}[{{$t(switchType(scope.row.UserFactory.Type))}}]</span>
            <span
              v-if="scope.row.User !== {}"
            >{{scope.row.User.NickName}} {{scope.row.User.Email}} {{scope.row.User.Phone}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('cmsg.labSpec')">
          <template slot-scope="scope">
            <span v-if="scope.row.Lab !== {}">{{scope.row.Lab.Name}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('cmsg.action')" width="320">
          <template slot-scope="scope">
            <el-button
              type="default"
              class="case_btn"
              size="mini"
              @click="editDevice(scope.row)"
            >{{$t('cmsg.change')}}</el-button>
            <el-button
              type="default"
              class="case_btn"
              size="mini"
              @click="deleteDevice(scope.row)"
            >{{$t('cmsg.delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[5, 10, 50, 100, 200, 300, 400]"
        :page-size="pageInfo.pageSize"
        :page-count="pageInfo.pages"
        layout="prev, pager, next, total, sizes"
        :total="pageInfo.total"
      ></el-pagination>
      <el-dialog
        :title="$t('cmsg.newDevice')"
        :visible.sync="dentalDeviceForm.visible"
        @close="resetDentalDeviceForm"
        @open="setDentalDeviceForm"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <p v-html="$t(dentalDeviceForm.description)"></p>
        <el-form
          :model="dentalDeviceForm.fields"
          label-width="100px;"
          ref="dentalDeviceForm"
          status-icon
          :validate-on-rule-change="false"
          :show-message="false"
        >
          <el-form-item :label="$t('cmsg.sn')" required prop="serialNum" :error="dentalDeviceForm.errors.SerialNum">
            <el-select
              v-model="dentalDeviceForm.fields.serialNum"
              filterable
              clearable
              remote
              :remote-method="remoteDevices"
              @change="setModelID"
            >
              <el-option :label="$t('cmsg.all')" value></el-option>
              <el-option v-for="im in devices" :key="im.Value" :label="im.Label" :value="im.Value"></el-option>
            </el-select>
          </el-form-item>
          <hr>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('cmsg.belongs')" prop="ownerFactoryID" :error="dentalDeviceForm.errors.OwnerFactoryID">
                <el-select
                  v-model="dentalDeviceForm.fields.ownerFactoryID"
                  filterable
                  clearable
                  remote
                  :remote-method="remoteFactories"
                >
                  <el-option :label="$t('cmsg.all')" value></el-option>
                  <el-option
                    v-for="im in factories"
                    :key="im.KeyName"
                    :label="im.KeyValue"
                    :value="im.KeyName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('cmsg.owner')" prop="ownerID" :error="dentalDeviceForm.errors.OwnerID">
                <el-select
                  v-model="dentalDeviceForm.fields.ownerID"
                  filterable
                  clearable
                  remote
                  :remote-method="remoteMembers"
                >
                  <el-option :label="$t('cmsg.all')" value></el-option>
                  <el-option
                    v-for="im in members"
                    :key="im.Value"
                    :label="im.Label"
                    :value="im.Value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <hr>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('cmsg.usageSpec')" prop="userFactoryID" :error="dentalDeviceForm.errors.UserFactoryID">
                <el-select
                  v-model="dentalDeviceForm.fields.userFactoryID"
                  filterable
                  clearable
                  remote
                  :remote-method="remoteFactories"
                >
                  <el-option :label="$t('cmsg.all')" value></el-option>
                  <el-option
                    v-for="im in factories"
                    :key="im.KeyName"
                    :label="im.KeyValue"
                    :value="im.KeyName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('cmsg.usageUser')" prop="userID" :error="dentalDeviceForm.errors.UserID">
                <el-select
                  v-model="dentalDeviceForm.fields.userID"
                  filterable
                  clearable
                  remote
                  :remote-method="remoteMembers"
                >
                  <el-option :label="$t('cmsg.all')" value></el-option>
                  <el-option
                    v-for="im in members"
                    :key="im.Value"
                    :label="im.Label"
                    :value="im.Value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <hr>
          <el-form-item :label="$t('cmsg.labSpec')" prop="labID" :error="dentalDeviceForm.errors.LabID">
            <el-select
              v-model="dentalDeviceForm.fields.labID"
              filterable
              clearable
              remote
              :remote-method="remoteLabs"
            >
              <el-option :label="$t('cmsg.all')" value></el-option>
              <el-option
                v-for="im in labs"
                :key="im.KeyName"
                :label="im.KeyValue"
                :value="im.KeyName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('cmsg.notes')" prop="notes" :error="dentalDeviceForm.errors.Notes">
            <el-input v-model="dentalDeviceForm.fields.notes" type="textarea"></el-input>
          </el-form-item>
        </el-form>
        <!-- <p v-if="dentalDeviceForm.err">{{dentalDeviceForm.err}}</p> -->
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetDentalDeviceForm">{{$t('cmsg.close')}}</el-button>
          <el-button type="primary" @click="submitDentalDeviceForm">{{$t('cmsg.submit')}}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      factoryType: {
        lab: "cmsg.lab",
        hospital: "cmsg.hospital"
      },
      searchForm: {
        modelID: "",
        ownerFactoryName: "",
        ownerFactoryType: "",
        ownerUserName: "",
        userFactoryName: "",
        userFactoryType: "",
        userUserName: "",
        serialNum: ""
      },
      factories: [],
      labs: [],
      devices: [],
      members: [],
      dentalDeviceForm: {
        visible: false,
        loading: false,
        description: "cmsg.dentalDeviceFormDesc",
        err: "",
        fields: {
          id: "",
          serialNum: "",
          notes: "",
          modelID: "",
          ownerFactoryID: "",
          ownerID: "",
          userFactoryID: "",
          labID: "",
          userID: ""
        },
        errors: {
          Id: null,
          SerialNum: null,
          Notes: null,
          ModelID: null,
          OwnerFactoryID: null,
          OwnerID: null,
          UserFactoryID: null,
          LabID: null,
          UserID: null
        }
      }
    };
  },
  methods: {
    deleteDevice(row) {
      console.log(row);
      this.$confirm(
        this.$t("cmsg.deleteDeviceDialogDesc", {
          sn: row.SN
        }),
        this.$t("cmsg.deleteDeviceDialogTitle"),
        {
          type: "warning",
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.$axios
            .get(`/api/u/dental/device/delete/${row.ID}`, {
              json: true,
              validateStatus: function(status) {
                return status >= 200 && status < 404; // default
              }
            })
            .then(res => {
              if (
                res.status === 200 &&
                res.data &&
                res.data.status === "success"
              ) {
                this.$message({
                  type: "success",
                  message: this.$t("cmsg.successAction")
                });
                var t = this;
                setTimeout(function() {
                  window.location = t.$router.resolve({
                    name: "devices",
                    query: t.$route.query
                  }).href;
                }, 3000);
              } else if (
                res.status === 200 &&
                res.data &&
                res.data.status !== "success"
              ) {
                this.$message({
                  type: "error",
                  message: `${this.$t("cmsg.mting")}: ${res.data.result}.`
                });
              } else {
                console.log(res);
                this.$message({
                  type: "warning",
                  message: this.$t("cmsg.mting")
                });
              }
            })
            .catch(e => {
              console.log(e);
              this.$message({
                type: "warning",
                message: this.$t("cmsg.mting")
              });
            });
        })
        .catch(e => {
          console.log(e);
        });
    },
    editDevice(row) {
      this.dentalDeviceForm.fields.id = row.ID;
      this.dentalDeviceForm.fields.serialNum = row.SN;
      this.dentalDeviceForm.fields.notes = row.Notes;
      if (row.DeviceModel != {}) {
        this.dentalDeviceForm.fields.modelID = row.DeviceModel.ID;
      }
      if (row.OwnerFactory != {}) {
        this.dentalDeviceForm.fields.ownerFactoryID = row.OwnerFactory.ID;
      }
      if (row.Owner != {}) {
        this.dentalDeviceForm.fields.ownerID = row.Owner.UserID;
      }
      if (row.UserFactory != {}) {
        this.dentalDeviceForm.fields.userFactoryID = row.UserFactory.ID;
      }
      if (row.Lab != {}) {
        this.dentalDeviceForm.fields.labID = row.Lab.ID;
      }
      if (row.User != {}) {
        this.dentalDeviceForm.fields.userID = row.User.UserID;
      }
      this.dentalDeviceForm.description =this.$t(this.dentalDeviceForm.description) +"<br />"+ this.$t(
        "cmsg.editDeviceDialogDesc",
        {
          sn: row.SN
        }
      );
      this.dentalDeviceForm.visible = true;
    },
    setModelID(v) {
      console.log(v);
      var t = this.dentalDeviceForm.fields.modelID;
      this.devices.forEach(device => {
        if (device.Value === v) {
          console.log(device);
          t = device.ModelID;
        }
      });
      this.dentalDeviceForm.fields.modelID = t;
    },
    submitDentalDeviceForm() {
      console.log(this.dentalDeviceForm.fields);
      if(this.dentalDeviceForm.fields.ownerFactoryID === "" && this.dentalDeviceForm.fields.ownerID === "") {
        this.dentalDeviceForm.errors["OwnerFactoryID"] = this.$t("cmsg.errField");
        this.dentalDeviceForm.errors["OwnerID"] = this.$t("cmsg.errField");
        return false;
      }
      //   return false;
      this.dentalDeviceForm.err = "";
      this.$refs["dentalDeviceForm"].validate(valid => {
        if (valid) {
          this.dentalDeviceForm.loading = true;
          var url = `/api/u/dental/device/add`;
          if (this.dentalDeviceForm.fields.id !== "") {
            url = `/api/u/dental/device/edit`;
          }
          this.$axios
            .post(url, this.dentalDeviceForm.fields, {
              json: true,
              validateStatus: function(status) {
                return status >= 200 && status < 404; // default
              }
            })
            .then(res => {
              console.log(res);
              this.dentalDeviceForm.loading = false;
              if (
                res.status === 200 &&
                res.data &&
                res.data.status === "success"
              ) {
                this.$message({
                  type: "success",
                  message: this.$t("cmsg.successAction")
                });
                this.dentalDeviceForm.visible = false;
                var t = this;
                setTimeout(function() {
                  t.resetDentalDeviceForm();
                  window.location = t.$router.resolve({
                    name: "devices",
                    query: t.$route.query
                  }).href;
                }, 3000);
              } else if (
                res.status === 200 &&
                res.data &&
                res.data.status !== "success"
              ) {
                var ermsg = {};
                try {
                ermsg = JSON.parse(res.data.result);
                }catch(e){
                  console.log(e);
                }
                Object.keys(ermsg).map((erk, i) => {
                  this.dentalDeviceForm.errors[erk] = this.$t("cmsg.errField");
                });
                this.dentalDeviceForm.err = res.data.result;
              } else if (
                res.status === 400 &&
                res.data &&
                res.data.status !== "success"
              ) {
                var ermsg = {};
                try {
                ermsg = JSON.parse(res.data.result);
                }catch(e){
                  console.log(e);
                }
                Object.keys(ermsg).map((erk, i) => {
                  this.dentalDeviceForm.errors[erk] = this.$t("cmsg.errField");
                });
                this.dentalDeviceForm.err = res.data.result;
              } else {
                console.log(res);
                this.$message({
                  type: "warning",
                  message: this.$t("cmsg.mting")
                });
              }
            })
            .catch(e => {
              console.log(e);
              this.dentalDeviceForm.loading = false;
              this.$message({
                type: "warning",
                message: this.$t("cmsg.mting")
              });
            });
        } else {
          this.dentalDeviceForm.loading = false;
          return false;
        }
      });
    },
    resetDentalDeviceForm() {
      this.dentalDeviceForm = {
        visible: false,
        loading: false,
        description: "cmsg.dentalDeviceFormDesc",
        err: "",
        fields: {
          id: "",
          serialNum: "",
          notes: "",
          modelID: "",
          ownerFactoryID: "",
          ownerID: "",
          userFactoryID: "",
          labID: "",
          userID: ""
        },
        errors: {
          Id: null,
          SerialNum: null,
          Notes: null,
          ModelID: null,
          OwnerFactoryID: null,
          OwnerID: null,
          UserFactoryID: null,
          LabID: null,
          UserID: null
        }
      };
    },
    async setDentalDeviceForm() {
      await this.$axios
        .get(`/api/u/dental/factory/options`, {
          validateStatus: function(status) {
            return status >= 200 && status < 404; // default
          }
        })
        .then(res => {
          console.log(res);
          if (
            res.status === 200 &&
            res.data &&
            res.data.result &&
            res.data.result !== null &&
            Array.isArray(res.data.result)
          ) {
            this.factories = res.data.result;
          }
        });
      await this.$axios
        .get(`/api/u/device/warehouse/options?deviceType=dentalScan`, {
          validateStatus: function(status) {
            return status >= 200 && status < 404; // default
          }
        })
        .then(res => {
          console.log(res);
          if (
            res.status === 200 &&
            res.data &&
            res.data.result &&
            res.data.result !== null &&
            Array.isArray(res.data.result)
          ) {
            this.devices = res.data.result;
          }
        });
      await this.$axios
        .get(`/api/u/dental/member/options`, {
          validateStatus: function(status) {
            return status >= 200 && status < 404; // default
          }
        })
        .then(res => {
          console.log(res);
          if (
            res.status === 200 &&
            res.data &&
            res.data.result &&
            res.data.result !== null &&
            Array.isArray(res.data.result)
          ) {
            this.members = res.data.result;
          }
        });
      await this.$axios
        .get(`/api/u/dental/factory/options?factoryType=lab`, {
          validateStatus: function(status) {
            return status >= 200 && status < 404; // default
          }
        })
        .then(res => {
          console.log(res);
          if (
            res.status === 200 &&
            res.data &&
            res.data.result &&
            res.data.result !== null &&
            Array.isArray(res.data.result)
          ) {
            this.labs = res.data.result;
          }
        });
    },
    async remoteFactories(query) {
      await this.$axios
        .get(`/api/u/dental/factory/options?pageSize=40000&name=${query}`, {
          validateStatus: function(status) {
            return status >= 200 && status < 404; // default
          }
        })
        .then(res => {
          console.log(res);
          if (
            res.status === 200 &&
            res.data &&
            res.data.result &&
            res.data.result !== null &&
            Array.isArray(res.data.result)
          ) {
            this.factories = res.data.result;
          } else {
            this.factories = []
          }
        });
    },
    async remoteLabs(query) {
      await this.$axios
        .get(
          `/api/u/dental/factory/options?pageSize=40000&factoryType=lab&name=${query}`,
          {
            validateStatus: function(status) {
              return status >= 200 && status < 404; // default
            }
          }
        )
        .then(res => {
          console.log(res);
          if (
            res.status === 200 &&
            res.data &&
            res.data.result &&
            res.data.result !== null &&
            Array.isArray(res.data.result)
          ) {
            this.labs = res.data.result;
          } else {
            this.labs = []
          }
        });
    },
    async remoteMembers(query) {
      await this.$axios
        .get(`/api/u/dental/member/options?pageSize=40000&name=${query}`, {
          validateStatus: function(status) {
            return status >= 200 && status < 404; // default
          }
        })
        .then(res => {
          console.log(res);
          if (
            res.status === 200 &&
            res.data &&
            res.data.result &&
            res.data.result !== null &&
            Array.isArray(res.data.result)
          ) {
            this.members = res.data.result;
          } else {
            this.members = []
          }
        });
    },
    async remoteDevices(query) {
      await this.$axios
        .get(
          `/api/u/device/warehouse/options?deviceType=dentalScan&pageSize=40000&ignoreModel=false&sn=${query}`,
          {
            validateStatus: function(status) {
              return status >= 200 && status < 404; // default
            }
          }
        )
        .then(res => {
          console.log("remoteDevices: ",res);
          if (
            res.status === 200 &&
            res.data &&
            res.data.result &&
            res.data.result !== null &&
            Array.isArray(res.data.result)
          ) {
            this.devices = res.data.result;
          } else {
            this.devices = []
          }
        });
    },
    switchType(v) {
      return this.factoryType[v];
    },
    toggleSearchForm() {
      var el = document.querySelector(".search_form");
      var elBtn = document.querySelector(".search_expand_area .el-icon--right");
      // console.log();
      if (el.style.display === "" || el.style.display === "none") {
        el.style.display = "block";
        elBtn.classList.remove("el-icon-arrow-right");
        elBtn.classList.add("el-icon-arrow-down");
      } else {
        el.style.display = "none";
        elBtn.classList.remove("el-icon-arrow-down");
        elBtn.classList.add("el-icon-arrow-right");
      }
    },
    onSearchReset() {
      console.log(this.$route.query);
      this.searchForm = {
        modelID: "",
        ownerFactoryName: "",
        ownerFactoryType: "",
        ownerUserName: "",
        userFactoryName: "",
        userFactoryType: "",
        userUserName: "",
        serialNum: ""
      };
    },
    initSearch() {
      var queryObj = this.$route.query;
      if (queryObj["modelID"]) {
        this.searchForm.modelID = queryObj["modelID"];
      }
      if (queryObj["serialNum"]) {
        this.searchForm.serialNum = queryObj["serialNum"];
      }
      if (queryObj["ownerFactoryName"]) {
        this.searchForm.ownerFactoryName = queryObj["ownerFactoryName"];
      }
      if (queryObj["ownerFactoryType"]) {
        this.searchForm.ownerFactoryType = queryObj["ownerFactoryType"];
      }
      if (queryObj["ownerUserName"]) {
        this.searchForm.ownerUserName = queryObj["ownerUserName"];
      }
      if (queryObj["userFactoryName"]) {
        this.searchForm.userFactoryName = queryObj["userFactoryName"];
      }
      if (queryObj["userFactoryType"]) {
        this.searchForm.userFactoryType = queryObj["userFactoryType"];
      }
      if (queryObj["userUserName"]) {
        this.searchForm.userUserName = queryObj["userUserName"];
      }
    },
    searchSubmit() {
      console.log(this.searchForm);
      var queryObj = this.$route.query;
      queryObj["modelID"] = this.searchForm.modelID;
      queryObj["serialNum"] = this.searchForm.serialNum;
      queryObj["ownerFactoryName"] = this.searchForm.ownerFactoryName;
      queryObj["ownerFactoryType"] = this.searchForm.ownerFactoryType;
      queryObj["ownerUserName"] = this.searchForm.ownerUserName;
      queryObj["userFactoryName"] = this.searchForm.userFactoryName;
      queryObj["userFactoryType"] = this.searchForm.userFactoryType;
      queryObj["userUserName"] = this.searchForm.userUserName;
      queryObj["page"] = 1;
      console.log(queryObj);
      Object.keys(queryObj).map((k, i) => {
        if (
          queryObj[k] === undefined ||
          queryObj[k] === "" ||
          (k === "page" && queryObj[k] === 1)
        ) {
          delete queryObj[k];
        }
      });
      console.log(queryObj);
      window.location = this.$router.resolve({
        name: "devices",
        query: queryObj
      }).href;
    },
    handleSizeChange(val) {
      console.log(val);
      var queryObj = this.$route.query;
      queryObj["pageSize"] = val;
      queryObj["page"] = 1;
      window.location = this.$router.resolve({
        name: "devices",
        query: queryObj
      }).href;
      // this.$redirect({name:'cases',query: queryObj});
    },
    handleCurrentChange(val) {
      console.log(val);
      var queryObj = this.$route.query;
      queryObj["page"] = val;
      window.location = this.$router.resolve({
        name: "devices",
        query: queryObj
      }).href;
      // this.$redirect({name:'cases',query: queryObj});
    }
  },
  mounted() {
    // console.log("this.perms: ", this.$store.state.perms);
    // console.log("this.$perms: ", this.$perms);
    this.initSearch();
    // this.setPerm();
    console.log("this.perms: ", this.perms);
    console.log("mounted:",pub.cdnUrl);
  },
  metaInfo() {
    return {
      title: this.$gf.sysParam(this.$gf.lang(), 'title') + "-" + this.$t("cmsg.devices")
    };
  },
  async asyncData(context) {
    let pageInfo = { page: 0, pageSize: 50, pages: 0, total: 0 };
    let items = [];
    let perms = [];
    var activeIndex = "all";
    if (context.req && context.req.query && context.req.query.status) {
      activeIndex = context.req.query.status;
    }
    await context.$axios
      .get("/api/u/dental/device/list", {
        json: true,
        params: context.route.query,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        // console.log(res)
        // var items = [];
        if (res.data.result && Array.isArray(res.data.result)) {
          items = res.data.result.map(item => {
            if (item.ChangeBy.Valid) {
              item.ChangeBy = JSON.parse(item.ChangeBy.String);
            } else {
              item.ChangeBy = {};
            }
            if (item.CreateBy.Valid) {
              item.CreateBy = JSON.parse(item.CreateBy.String);
            } else {
              item.CreateBy = {};
            }
            if (item.DeviceModel.Valid) {
              item.DeviceModel = JSON.parse(item.DeviceModel.String);
            } else {
              item.DeviceModel = {};
            }
            if (item.OwnerFactory.Valid) {
              item.OwnerFactory = JSON.parse(item.OwnerFactory.String);
            } else {
              item.OwnerFactory = {};
            }
            if (item.OwnerFactoryAdmins.Valid) {
              item.OwnerFactoryAdmins = JSON.parse(
                item.OwnerFactoryAdmins.String
              );
            } else {
              item.OwnerFactoryAdmins = {};
            }
            if (item.Owner.Valid) {
              item.Owner = JSON.parse(item.Owner.String);
            } else {
              item.Owner = {};
            }
            if (item.UserFactory.Valid) {
              item.UserFactory = JSON.parse(item.UserFactory.String);
            } else {
              item.UserFactory = {};
            }
            if (item.Lab.Valid) {
              item.Lab = JSON.parse(item.Lab.String);
            } else {
              item.Lab = {};
            }
            if (item.User.Valid) {
              item.User = JSON.parse(item.User.String);
            } else {
              item.User = {};
            }
            return item;
          });
          pageInfo = res.data.pageInfo;
        }
      })
      .catch(e => {
        console.log(e);
      });
    await context.$axios
      .get(`/api/u/settings/b/up`, {
        json: true,
        validateStatus: function(status) {
          return status >= 200 && status < 404; // default
        }
      })
      .then(res => {
        if (
          res.status === 200 &&
          res.data &&
          res.data.status === "success" &&
          res.data.result !== null
        ) {
          // console.log(res);
          perms = res.data.result;
        }
      })
      .catch(e => {
        console.log(e);
      });
    // console.log(items);
    return {
      pageInfo: pageInfo,
      items: items,
      perms: perms,
      tableLoading: false,
      activeIndex: activeIndex
    };
  }
};
</script>
<style lang="scss">
.fileDownPopover {
  .el-button {
    display: block;
    margin-left: 0px;
  }
}
#devices {
  .main {
    background-color: #f7f9fb;
    padding: 15px;
    text-align: left;
    .case_nav {
      display: flex;
      overflow: auto;
    }
    .el-menu-item {
      display: inline;
      border-top: 1px solid #e6e6e6;
      border-left: 1px solid #e6e6e6;
    }
    .el-menu-item.is-active {
      background-color: #f3f3f3;
    }
    .el-menu-item:last-of-type {
      border-right: 1px solid #e6e6e6;
    }
    .hidden_delivery {
      display: none;
    }
    .large_preview {
      width: 80%;
    }
    .large_preview .el-message-box__content {
      overflow: auto;
    }
    .el-table__expanded-cell[class*="cell"] {
      padding: 0px 0px 15px 0px;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      border-top-width: 0px;
    }
    .case_btn {
      margin-right: 5px;
      margin-bottom: 5px;
      margin-left: 0px !important;
    }
    .search_expand_area {
      display: none;
    }
    .search_form {
      display: block;
    }
    @media screen and (min-width: 1020px) {
      .search_expand_area {
        display: none;
      }
      .search_form {
        display: block;
      }
    }
    .el-table__expanded-cell[class*="cell"] {
      padding-bottom: 0px !important;
    }
    @media screen and (max-width: 1020px) {
      .search_expand_area {
        display: block;
      }
      .search_form {
        display: none;
      }
      .el-menu-item [class^="el-icon-"] {
        margin-right: 0px;
      }
      .el-menu-item:not(.is-active) .dp_title {
        display: none;
        /* display: inline; */
      }
      .is-active .dp_title {
        display: inline;
      }
      .el-menu-item {
        padding: 0 0px 0 5px;
      }
      .el-pager li:not(.active) {
        display: none;
      }
    }
  }
}
</style>
